import React, { useEffect, useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Table,
    TableBody,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    Paper,
    CircularProgress,
    Box,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";
import { getlearnerSubmission } from "../../../services/reportServices/mentorReportServices/PracticeReportServices";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: "#7e7e7e",
        color: theme.palette.common.white,
        textTransform: "capitalize",
        fontSize: 16,
        fontWeight: 600,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        textTransform: "capitalize",
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd), &:nth-of-type(even)": {
        backgroundColor: theme.palette.action.hover,
        borderBottom: "1px solid rgba(224, 224, 224, 1)",
    },
    "&:last-child td, &:last-child th": {
        border: 0,
    },
}));

const LearnerSubmittedModal = ({
    open,
    onClose,
    selected,
    loading = false,
    title = "Learner Submissions",
}) => {
    const [data, setData] = useState([])
    const safeData = Array.isArray(data) ? data : [];
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(50);
    const paginatedRows = safeData?.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
    );

    const handleChangePage = (_, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (e) => {
        setRowsPerPage(parseInt(e.target.value, 10));
        setPage(0);
    };
    useEffect(() => {
        if (selected) {
            getlearnerSubmission(selected?.lab, selected?.makerplanID, selected?.moduleID, selected?.topicID,selected?.daily_practice_id)
                .then((response) => setData(response?.data?.data || []))
                .catch(() => setData([]));
        }
    }, [selected]);
    return (
        <Dialog open={open} onClose={onClose} maxWidth="xl" fullWidth>
            <DialogTitle sx={{ m: 0, p: 2 }}>
                {title}
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{ position: "absolute", right: 8, top: 8, color: "grey.500" }}
                >
                    <Close />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{ px: 2 }}>
                <TableContainer
                    component={Paper}
                    className="table-container"
                    sx={{ width: "100%", overflowX: "auto" }}
                >
                    <Table
                        sx={{ tableLayout: "auto", width: "max-content", minWidth: "100%" }}
                        aria-label="learner submissions"
                    >
                        <TableHead>
                            <TableRow>
                                <StyledTableCell>Name</StyledTableCell>
                                <StyledTableCell>Email</StyledTableCell>
                                <StyledTableCell>Lab Name</StyledTableCell>
                                <StyledTableCell>Maker Plan</StyledTableCell>
                                <StyledTableCell>Module</StyledTableCell>
                                <StyledTableCell>Topic</StyledTableCell>

                                <StyledTableCell>Submitted At</StyledTableCell>
                                <StyledTableCell>#Submitted URL</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {loading ? (
                                <TableRow>
                                    <StyledTableCell colSpan={10} align="center">
                                        <Box
                                            display="flex"
                                            justifyContent="center"
                                            alignItems="center"
                                            height="50px"
                                        >
                                            <CircularProgress />
                                        </Box>
                                    </StyledTableCell>
                                </TableRow>
                            ) : paginatedRows?.length > 0 ? (
                                paginatedRows.map((row, index) => (
                                    <StyledTableRow key={index}>
                                        <StyledTableCell>{row?.Name || "-"}</StyledTableCell>
                                        <StyledTableCell>{row?.email || "-"}</StyledTableCell>
                                        <StyledTableCell>{row?.lab_name || "-"}</StyledTableCell>
                                        <StyledTableCell>{row?.makerplan_name || "-"}</StyledTableCell>
                                        <StyledTableCell>{row?.module_name || "-"}</StyledTableCell>
                                        <StyledTableCell>{row?.topic_name || "-"}</StyledTableCell>
                                        <StyledTableCell>{row?.submitted_at || "-"}</StyledTableCell>
                                        <StyledTableCell>
                                            {row?.submission_link ? (
                                                <a
                                                    href={row.submission_link}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{ textDecoration: "none", color: "#1976d2" }}
                                                >
                                                    {row.submission_link}
                                                </a>
                                            ) : (
                                                "-"
                                            )}
                                        </StyledTableCell>


                                    </StyledTableRow>
                                ))
                            ) : (
                                <StyledTableRow>
                                    <StyledTableCell
                                        colSpan={10}
                                        align="center"
                                        sx={{ fontWeight: 600, color: "grey" }}
                                    >
                                        No records found.
                                    </StyledTableCell>
                                </StyledTableRow>
                            )}
                        </TableBody>
                    </Table>
                    <TablePagination
                        rowsPerPageOptions={[10,20,30,60,100]}
                        component="div"
                        count={data?.length || 0}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </TableContainer>
            </DialogContent>
        </Dialog>
    );
};

export default LearnerSubmittedModal;
